import { render, staticRenderFns } from "./filtrosGeneralMayoreo.vue?vue&type=template&id=16a7e5f0&scoped=true&"
import script from "./filtrosGeneralMayoreo.vue?vue&type=script&lang=js&"
export * from "./filtrosGeneralMayoreo.vue?vue&type=script&lang=js&"
import style0 from "./filtrosGeneralMayoreo.vue?vue&type=style&index=0&id=16a7e5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7e5f0",
  null
  
)

export default component.exports